import { ref, computed } from 'vue';
import { useReportsStore } from '../store';
import trayArrowDownIcon from '../assets/icons/tray-arrow-down.svg?url';
import type { NavigationItem } from '../types/navigation';

export function useDownloads() {
  const reportsStore = useReportsStore();
  const allDownloadsMap = ref(new Map<string, NavigationItem>());

  const fetchAllGradeDownloads = async (
    reportId: string,
  ): Promise<NavigationItem[]> => {
    try {
      const report = await reportsStore.fetchReportDetail(reportId);
      if (!report?.report_grades) return [];

      const allDownloads: NavigationItem[] = [];
      const seenUris = new Set<string>();

      for (const grade of report.report_grades) {
        const gradeReport = await reportsStore.fetchReportGrade(
          reportId,
          grade.slug,
        );

        if (gradeReport?.downloads && Array.isArray(gradeReport.downloads)) {
          gradeReport.downloads.forEach((download: any) => {
            // Deduplicate by URI across all grades (same as original OverviewSideNav)
            if (!seenUris.has(download.uri)) {
              seenUris.add(download.uri);
              allDownloads.push({
                title: download.name || 'Download',
                value: `download-${download.name?.toLowerCase().replace(/\s+/g, '-') || 'file'}`,
                titleIcon: trayArrowDownIcon,
                href: download.uri,
                download: {
                  uri: download.uri,
                  name: download.name,
                  extension: download.extension,
                  mime_type: download.mime_type,
                },
              });
            }
          });
        }
      }

      return allDownloads;
    } catch (error) {
      console.error('Error fetching all grade downloads:', error);
      return [];
    }
  };

  const fetchGradeDownloads = (gradeReport: any): NavigationItem[] => {
    if (!gradeReport?.downloads) return [];

    return gradeReport.downloads.map((download: any, index: number) => ({
      title: download.name || 'Download',
      value: `download-${gradeReport.slug}-${index}`,
      href: download.uri,
      titleIcon: trayArrowDownIcon,
      download: {
        uri: download.uri,
        name: download.name,
        extension: download.extension,
        mime_type: download.mime_type,
      },
    }));
  };

  return {
    fetchAllGradeDownloads,
    fetchGradeDownloads,
  };
}
